const CfitOptionsWidths = [
  48, 64, 96, 128, 225, 375, 380, 450, 600, 750, 770, 800, 840, 900, 1170, 1200,
];

export type CfitOptionsWidth =
  | 48
  | 64
  | 96
  | 128
  | 225
  | 375
  | 380
  | 450
  | 600
  | 750
  | 770
  | 800
  | 840
  | 900
  | 1170
  | 1200;

type CfitOptionsFit = 'crop' | 'contain';

interface CfitOptions {
  alt: string;
  width: CfitOptionsWidth;
  height?: number;
  quality?: number;
  fit?: CfitOptionsFit;
  format?: 'jpeg' | 'webp';
  loading?: React.ImgHTMLAttributes<HTMLImageElement>['loading'];
}

export interface CfitImage extends CfitOptions {
  src: string;
  srcSet?: string;
}

export const urlToCfit = (url: string, options: CfitOptions): CfitImage => {
  const u = new URL(url);
  const path = u.pathname;
  const parts = path.split('/');
  const lastId = parts.pop();
  const firstId = parts.pop();

  const updateedUrl = new URL(`${process.env.NEXT_PUBLIC_CFIT_WAYKE}/${firstId}/${lastId}`);
  updateedUrl.searchParams.set('w', options.width.toString());
  if (options.height) {
    updateedUrl.searchParams.set('h', options.height.toString());
  }
  if (options.quality) {
    updateedUrl.searchParams.set('q', options.quality.toString());
  }
  if (options.fit) {
    updateedUrl.searchParams.set('fit', options.fit);
  }
  if (options.format) {
    updateedUrl.searchParams.set('format', options.format);
  }

  const revion = u.searchParams.get('r');
  if (revion) {
    updateedUrl.searchParams.set('r', revion);
  }
  updateedUrl.searchParams.sort();

  const Cfit: CfitImage = {
    src: updateedUrl.toString(),
    ...options,
  };

  if (CfitOptionsWidths.includes(options.width * 2)) {
    const srcSetUrl = new URL(updateedUrl.toString());
    srcSetUrl.searchParams.set('w', (options.width * 2).toString());
    if (options.height) {
      srcSetUrl.searchParams.set('h', (options.height * 2).toString());
    }
    srcSetUrl.searchParams.sort();
    Cfit.srcSet = `${updateedUrl.toString()} 1x, ${srcSetUrl.toString()} 2x`;
  }

  if (options.loading) {
    Cfit.loading = options.loading;
  }

  return Cfit;
};
